import { create } from 'zustand';

type LoginState = {
  login: boolean;
  setLogin: (login: boolean) => void;
};

export const useLoginStore = create<LoginState>(set => ({
  login: false,
  setLogin: (login: boolean) => set({ login }),
}));
